import React from 'react'
import Header from "../components/Header";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";
export default function TermsPage() {
    return (
        <div>
            <Header />
            <Breadcrumb />
            <div className="legal-container">
                <h1>Terms and Conditions</h1>
                <section>
                    <h2>1. Introduction</h2>
                    <p>
                        Welcome to our website. By accessing or using this site, you agree to
                        comply with and be bound by these Terms and Conditions. If you do not
                        agree, please do not use our website.
                    </p>
                </section>
                <section>
                    <h2>2. Use of Website</h2>
                    <ul>
                        <li>You must be at least 18 years old or using the website under supervision.</li>
                        <li>You agree not to use the website for any illegal or unauthorized purpose.</li>
                        <li>You must not misuse, hack, or disrupt the website.</li>
                    </ul>
                </section>
                <section>
                    <h2>3. Products and Services</h2>
                    <ul>
                        <li>All products listed are subject to availability.</li>
                        <li>We reserve the right to modify or discontinue products without notice.</li>
                        <li>Prices are subject to change at any time.</li>
                    </ul>
                </section>
                <section>
                    <h2>4. Orders and Payments</h2>
                    <ul>
                        <li>By placing an order, you agree to provide accurate information.</li>
                        <li>We reserve the right to cancel or refuse any order.</li>
                        <li>Payments must be made through approved payment methods.</li>
                    </ul>
                </section>
                <section>
                    <h2>5. Shipping and Delivery</h2>
                    <ul>
                        <li>Delivery times are estimated and may vary.</li>
                        <li>We are not responsible for delays caused by third-party courier services.</li>
                        <li>Shipping charges (if any) will be mentioned at checkout.</li>
                    </ul>
                </section>
                <section>
                    <h2>6. Returns and Refunds</h2>
                    <ul>
                        <li>
                            No exchange available for size issues. Please check measurements before ordering.
                        </li>
                        <li>
                            Items must be unused and in original condition. A 360° opening video is required
                            for damage or size issues, and damages must be clearly shown.
                        </li>
                        <li>Refunds will be processed after inspection.</li>
                    </ul>
                </section>
                <section>
                    <h2>7. Intellectual Property</h2>
                    <ul>
                        <li>All content (images, logo, text, designs) belongs to the website owner.</li>
                        <li>You may not copy, reproduce, or use any content without permission.</li>
                    </ul>
                </section>
                <section>
                    <h2>8. User Accounts</h2>
                    <ul>
                        <li>You are responsible for maintaining the confidentiality of your account.</li>
                        <li>Any activity under your account is your responsibility.</li>
                    </ul>
                </section>
                <section>
                    <h2>9. Limitation of Liability</h2>
                    <ul>
                        <li>We are not liable for any direct or indirect damages arising from website use.</li>
                        <li>Use the website at your own risk.</li>
                    </ul>
                </section>
                <section>
                    <h2>10. Privacy Policy</h2>
                    <p>Your personal information will be handled according to our Privacy Policy.</p>
                </section>
                <section>
                    <h2>11. Changes to Terms</h2>
                    <ul>
                        <li>We may update these Terms at any time without prior notice.</li>
                        <li>Continued use of the website means you accept the updated terms.</li>
                    </ul>
                </section>
                <section>
                    <h2>12. Governing Law</h2>
                    <p>These Terms shall be governed by the laws of India.</p>
                </section>
                <section>
                    <h2>13. Contact Information</h2>
                    <p>If you have any questions about these Terms, please contact us:</p>
                    <p>📧 Email: senthanamuthankidswear@gmail.com</p>
                    <p>📞 Phone: 9360990836</p>
                </section>
            </div>
            <Footer />
        </div>
    )
}
